import Heading from "../../shared/ui/Typography/Heading";
import Text from "../../shared/ui/Typography/Text";
import { CompanyFinder } from "../../features/companyFinder";

// CompanyFinderScreen — route landing for /companies/find. Mounts
// under MainLayout. Thin composition wrapper around the feature
// widget. No selectors, no dispatch, no state — all owned by the
// widget.

function CompanyFinderScreen() {
  return (
    <section
      className="feature-company-finder"
      id="Csection"
      tabIndex="-1"
    >
      <div className="container">
        <header className="feature-company-finder__header">
          <Heading level={1} variant="page">
            Знайти компанію
          </Heading>
          <Text as="p" size="sm" tone="secondary">
            Виберіть компанію, щоб відкрити її безпечний профіль.
          </Text>
        </header>

        <CompanyFinder />
      </div>
    </section>
  );
}

export default CompanyFinderScreen;
